var _path, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAngryFace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_26",
    "data-name": "Group 26",
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.782,
    height: 41.782,
    viewBox: "0 0 41.782 41.782",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M1365.248,267.765a20.891,20.891,0,1,1-20.891-20.891A20.89,20.89,0,0,1,1365.248,267.765Z",
    transform: "translate(-1323.466 -246.874)",
    fill: "#f6b16c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(10.726 19.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M1349.975,289.3c0,1.681-.96,3.046-2.145,3.046s-2.145-1.365-2.145-3.046.961-3.045,2.145-3.045S1349.975,287.614,1349.975,289.3Z",
    transform: "translate(-1345.685 -286.251)",
    fill: "#562912"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(16.038)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M1383.2,289.3c0,1.681-.96,3.046-2.146,3.046s-2.145-1.365-2.145-3.046.96-3.045,2.145-3.045S1383.2,287.614,1383.2,289.3Z",
    transform: "translate(-1378.91 -286.251)",
    fill: "#562912"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(9.861 14.388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M1350.315,282.344a.59.59,0,0,1-.565-.423,6.16,6.16,0,0,0-5.333-4.066.589.589,0,1,1,.133-1.17,7.348,7.348,0,0,1,6.331,4.9.589.589,0,0,1-.4.731A.57.57,0,0,1,1350.315,282.344Z",
    transform: "translate(-1343.894 -276.681)",
    fill: "#562912"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(15.049 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M1375.66,282.345a.573.573,0,0,1-.167-.023.588.588,0,0,1-.4-.731,7.343,7.343,0,0,1,6.33-4.9.589.589,0,0,1,.133,1.17,6.161,6.161,0,0,0-5.333,4.066A.589.589,0,0,1,1375.66,282.345Z",
    transform: "translate(-1375.071 -276.682)",
    fill: "#562912"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(15.735 28.411)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M1365.423,309.229a.948.948,0,0,1-.647-.254,5.2,5.2,0,0,0-3.363-1.341,5.1,5.1,0,0,0-3.745,1.333.949.949,0,1,1-1.311-1.374,7.28,7.28,0,0,1,9.714-.008.95.95,0,0,1-.647,1.644Z",
    transform: "translate(-1356.063 -305.73)",
    fill: "#562912"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngryFace);
export default __webpack_public_path__ + "static/media/angry-face.4de74fe6.svg";
export { ForwardRef as ReactComponent };